// src/app/components/notification-filter/notification-filter.component.ts
import { Component, OnInit, OnDestroy, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationFilterService, FilterType } from '../../shared/services/notification-filter.service';
import { NotificationItem } from '../../models/notification.model';
import { ViewEncapsulation } from '@angular/core';
import { Subject} from 'rxjs';

@Component({
    selector: 'app-notification-filter',
    standalone: true,
    imports: [CommonModule, TranslateModule, MatIconModule, MatSlideToggleModule],
    templateUrl: './notification-filter.component.html',
    styleUrls: ['./notification-filter.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NotificationFilterComponent implements OnInit, OnDestroy {
    @Input() notifications: NotificationItem[] = [];
    @Input() storageKey: string = 'notification_filter_unread';

    private destroy$ = new Subject<void>();
    private filterService = inject(NotificationFilterService);

    showOnlyUnread = true;
    private readonly STORAGE_KEY_PREFIX = 'secure_';

    ngOnInit(): void {
        this.loadToggleState();

        this.applyFilter();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onToggleChange(event: any): void {
        this.showOnlyUnread = event.checked;
        console.log('[NotificationFilter] Toggle changed to:', this.showOnlyUnread ? 'unread only' : 'all');

        this.saveToggleState();

        this.applyFilter();
    }

    private applyFilter(): void {
        const filterType = this.showOnlyUnread ? FilterType.Unread : FilterType.All;
        this.filterService.setFilter(filterType);

        if (this.notifications.length > 0) {
            this.filterService.setNotifications(this.notifications);
        }
    }

    private get localStorageKey() {
        return this.STORAGE_KEY_PREFIX + this.storageKey;
    }

    private saveToggleState(): void {
        localStorage.setItem(this.localStorageKey, this.showOnlyUnread.toString());
    }

    private loadToggleState(): void {
        const saved = localStorage.getItem(this.localStorageKey);
        this.showOnlyUnread = saved === 'true';
    }

    ngOnChanges(): void {
        if (this.notifications.length > 0) {
            this.applyFilter();
        }
    }
}